/**
 * TanStack Query hook for GET /api/v1/admin/health (Phase 12.6).
 *
 * Health is on-demand: the admin clicks "Re-check" to call ``refetch``.
 * No background polling, since each call hits five upstream services.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import api from "@/lib/api";
import type { HealthSnapshot } from "@/types/api";

export const ADMIN_HEALTH_QUERY_KEY = ["admin", "health"] as const;

export function useAdminHealth(): UseQueryResult<HealthSnapshot> {
  return useQuery({
    queryKey: ADMIN_HEALTH_QUERY_KEY,
    queryFn: async () => {
      const response = await api.get<HealthSnapshot>("/admin/health");
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
}
